import request from "@/utils/request";

export function appointmentCalendar() {
    return request({
        url: '/app/reservation/appointment-calendar',
        method: 'get',
    })
}

export function appointPlan(params) {
    return request({
        url: '/app/reservation/appoint-plan',
        method: 'get',
        params
    })
}

export function serviceList(params) {
    return request({
        url: '/app/reservation/service-list',
        method: 'get',
        params
    })
}

export function previewPlan(params) {
    return request({
        url: '/app/reservation/preview-plan',
        method: 'get',
        params
    })
}

export function typeList(params) {
    return request({
        url: '/app/reservation/type-list',
        method: 'get',
        params
    })
}

export function timeList(params) {
    return request({
        url: '/app/reservation/time-list',
        method: 'get',
        params
    })
}

export function requestApply(data) {
    return request({
        url: '/app/reservation/request-apply',
        method: 'post',
        data
    })
}

export function cancelApply(data) {
    return request({
        url: '/app/reservation/cancel-apply',
        method: 'post',
        data
    })
}


export function applyList(data) {
    return request({
        url: '/app/reservation/apply-list',
        method: 'post',
        data
    })
}
